import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderHandlerService {
  outgoingServicesCount = 0;
  manualOverride = false;

  private loaderEventSource = new Subject<boolean>();
  handler$ = this.loaderEventSource.asObservable();

  constructor() {}

  enableManualLoader() {
    this.manualOverride = true;
    this.loaderEventSource.next(true); 
  }

  disableManualLoader() {
    this.manualOverride = false;

    // only turn off if no pending API calls
    if (this.outgoingServicesCount <= 0) {
      this.loaderEventSource.next(false);
    }
  }

  toggleLoader(serviceFlag: number) {
    if (this.manualOverride) {
      // During manual mode, ignore all API toggles
      if (serviceFlag === 1) this.outgoingServicesCount++;
      if (serviceFlag === 0) this.outgoingServicesCount--;
      return;
    }

    switch (serviceFlag) {
      case 1:
        this.outgoingServicesCount++;
        this.loaderEventSource.next(true);
        break;

      case 0:
        this.outgoingServicesCount--;
        if (this.outgoingServicesCount <= 0) {
          this.outgoingServicesCount = 0;
          this.loaderEventSource.next(false);
        }
        break;
    }
  }
}
